import { Controller } from "@hotwired/stimulus"

const NAV_ROUTES = [
  { pattern: /^\/$/, name: "dashboard" },
  { pattern: /^\/match/, name: "vin-match" },
  { pattern: /^\/decode/, name: "single-vin" },
  { pattern: /^\/ptv/, name: "plate-to-vin" },
  { pattern: /^\/mh/, name: "mileage-history" },
];

export default class extends Controller {
  static targets = ["item"];

  connect() {
    this._onNavigate = () => this.highlight();
    document.addEventListener("turbo:load", this._onNavigate);
    document.addEventListener("turbo:render", this._onNavigate);
    this.highlight();
  }

  disconnect() {
    document.removeEventListener("turbo:load", this._onNavigate);
    document.removeEventListener("turbo:render", this._onNavigate);
  }

  highlight() {
    const path = window.location.pathname;
    const activeName = this._matchRoute(path);

    this.itemTargets.forEach((item) => {
      if (item.dataset.route === activeName) {
        item.classList.add("active");
      } else {
        item.classList.remove("active");
      }
    });
  }

  _matchRoute(path) {
    for (const route of NAV_ROUTES) {
      if (route.pattern.test(path)) return route.name;
    }
    return null;
  }
}
